import React, { Fragment, useEffect, useRef, useState } from 'react';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import withScriptjs from '../../services/hocs/withScriptjs';
import bemCn from 'bem-cn';
import { slugify } from '../../helpers/text';
import { IMG_RESIZES } from '../../consts/resizer.consts';
import { ImageHelper } from '../../classes/image-helper.class';
import useMobileScreen from '../../services/hooks/useMobileScreen';
import { getInitState } from '../../helpers/spot-slug';
import { DEFAULT_FAQS } from '../../consts/blog-dog-rescues.consts';
import { RouteFormatter } from '../../routes';
import { GOOGLE_MAP_URL } from '../../consts/env.consts';
import { COOKIE_PARAM_NAME } from '../../consts/cookies.consts';
import NavigationGuestUnauth from '../../components/navigation-guest-unauth/desktop-ssr';
import BlogArticleDesktopLow from '../../components/blog-article-desktop-low';
import SniffAppleMapsRescue from '../../components/sniff-apple-maps/dog-rescues';
import { Banner1, Banner2 } from '../../components/blogs/banners';
import PaginationNextSSR from '../../components/pagination/next-ssr';
import BlogArticleSimple from '../../components/blog-article-simple';
import SkeletonSpotItem from '../../components/skeleton/spot-item';
import SeoAnimalShelter from '../../components/seo-animal-shelter';
import SpotBreadcrumbs from '../../components/spot-breadcrumbs';
import BlogCategories from '../../components/blog-categories';
import SniffCheckbox from '../../components/sniff-checkbox';
import SniffButton from '../../components/sniff-button';
import ModalMobile from '../../components/modal-mobile';
import PictureSet from '../../components/picture-set';
import BlogTopNav from '../../components/blog-top-nav';
import BlogFooter from '../../components/blog-footer';
import FooterNew from '../../components/footer-new';
import Preloader from '../../components/preloader';
import SnifHr from '../../components/snif-hr';
import SvgCommentQuote from 'src/assets/svg/SvgCommentQuote.svg';
import SvgChevronLeft from 'src/assets/svg/SvgChevronLeft.svg';
import SvgMyLocation from 'src/assets/svg/SvgMyLocation.svg';
import SvgFilterNew from 'src/assets/svg/SvgFilterNew.svg';
import SvgRefresh from 'src/assets/svg/SvgRefresh.svg';
import SvgLoading from 'src/assets/svg/SvgLoading.svg';
import SvgSearch from 'src/assets/svg/SvgSearch.svg';
import SvgTrophy from 'src/assets/svg/SvgTrophy.svg';
import SvgCross from 'src/assets/svg/SvgCross.svg';
import SvgSend from 'src/assets/svg/SvgSend.svg';
import SvgList from 'src/assets/svg/SvgList.svg';
import SvgPin from 'src/assets/svg/SvgPin.svg';
import SvgMap from 'src/assets/svg/SvgMap.svg';
import '../blog/post.scss';
import './index.scss';

const CookieService = require('../../services/cookie.service');
const useGetMapkitToken = require('../../services/hooks/useGetMapkitToken');
const useGetDogRescuesPage = require('../../services/hooks/useGetDogRescuesPage');
const useGetBlogCategories = require('../../services/hooks/useGetBlogCategories');
const useGetDogRescuesPages = require('../../services/hooks/useGetDogRescuesPages');

const b = bemCn('sniff-blog-post');
const bDog = bemCn('sniff-dog-rescue-search');

const PAGE_TYPES = {
    CITY: 'CITY',
    STATE: 'STATE',
    COUNTRY: 'COUNTRY',
    PROFILE: 'PROFILE',
    SPECIALIZATION: 'SPECIALIZATION',
};

const RESCUES_LIMIT = 30;
const MAX_TESTI_CHAR_LIMIT = 65;
const SPEC_TYPES = ['Pit Bull', 'Senior dog', 'German Shepherd', 'Puppy', 'Husky', 'Golden Retriever', 'Great Dane', 'Boxer'];
const FULL_SPEC_TYPES = [
    'Australian Shepherd',
    'Beagle',
    'Border Collie',
    'Boxer',
    'Chihuahua',
    'Cocker Spaniel',
    'Corgi',
    'Dachshund',
    'English Bulldog',
    'French Bulldog',
    'German Shepherd',
    'Goldendoodle',
    'Golden Retriever',
    'Great Dane',
    'Greyhound',
    'Husky',
    'Italian Greyhound',
    'Jack Russell',
    'Labrador',
    'Maltese',
    'Pit Bull',
    'Pomeranian',
    'Poodle',
    'Pug',
    'Puppy',
    'Rottweiler',
    'Senior dog',
    'Shih Tzu',
    'Small dog',
    'Yorkie',
];

const Divider = () => (
    <div className="py-4">
        <SnifHr w100 />
    </div>
);

const RenderRanks = ({ countryRank, stateRank, cityRank, state, city }) => {
    const cRanks = countryRank ? <>#{countryRank} in United States</> : null;
    const sRanks =
        state && stateRank ? (
            <>
                #{stateRank} in {state}
            </>
        ) : null;

    const cityRanks =
        city && cityRank ? (
            <>
                #{cityRank} in {city}
            </>
        ) : null;
    const ranks = [];
    cRanks && ranks.push(cRanks);
    sRanks && ranks.push(sRanks);
    cityRanks && ranks.push(cityRanks);

    if (ranks.length == 0) {
        return '';
    }

    return (
        <p className="snif-s1 text-medium">
            {ranks.map((r, i) => (
                <React.Fragment key={i}>
                    {r}
                    {i < ranks.length - 1 ? ', ' : ''}
                </React.Fragment>
            ))}
        </p>
    );
};

const AutoComplete = ({ address, handleToMyLoc, onChange, onSelect, value, toggleDelete }) => {
    const inputRef = useRef(null);
    const [localFocus, setLocalFocus] = useState(false);
    const [addr, setAddr] = useState('');

    const onFocus = () => setLocalFocus(true);
    const onBlur = () => setTimeout(() => setLocalFocus(false), 150);

    const handleDelete = () => {
        toggleDelete();
        inputRef.current.focus();
    };

    const onSelectLoc = (a) => {
        onSelect(a);
        setAddr(a);
        onBlur();
    };

    const onToMyLoc = () => {
        handleToMyLoc();
        setAddr('My Location');
        onBlur();
    };

    useEffect(() => {
        setAddr(value);
    }, [value]);

    return (
        <>
            <PlacesAutocomplete
                searchOptions={{
                    types: ['country', 'locality', 'administrative_area_level_1', 'administrative_area_level_3'],
                    componentRestrictions: { country: 'us' },
                }}
                value={addr}
                onChange={onChange}
                onSelect={onSelectLoc}
                debounce={400}
                shouldFetchSuggestions={value.length >= 2}
            >
                {({ getInputProps, suggestions, getSuggestionItemProps }) => (
                    <div className="w-100">
                        <input
                            ref={inputRef}
                            onBlur={onBlur}
                            onFocus={onFocus}
                            {...getInputProps({ placeholder: address.addr || 'United States' })}
                        />
                        <div className={bDog('search-results').mix(localFocus ? '' : 'd-none')}>
                            <div className={bDog('search-results_item')} onClick={onToMyLoc}>
                                <SvgSend className="text-primary" />
                                <div>
                                    <p className="snif-p snif-medium">Current location</p>
                                </div>
                            </div>
                            {suggestions.map((sug) => {
                                const className = sug.active ? bDog('search-results_item', { active: true }) : bDog('search-results_item');
                                return (
                                    <div key={sug.id} {...getSuggestionItemProps(sug, { className })}>
                                        <SvgPin />
                                        <div>
                                            <p className="snif-p snif-semibold">
                                                {sug.id !== undefined ? sug.title : sug.formattedSuggestion?.mainText}
                                            </p>
                                            <p className="snif-s2 snif-medium">
                                                {sug.id !== undefined
                                                    ? `${sug.city}${sug.state ? `, ${sug.state}` : ''}`
                                                    : sug.formattedSuggestion?.secondaryText}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                )}
            </PlacesAutocomplete>
            <div className={bDog('search-comp_delete-icon')} onClick={handleDelete}>
                <SvgCross />
            </div>
        </>
    );
};

const LocationSearch = withScriptjs((props) => <AutoComplete {...props} />);

const getBread = ({ city, pageType, query, rescueName, slug, state, specialization }) => {
    const bread = [
        { name: 'Blog', url: RouteFormatter.blog({}) },
        { name: 'Dog Rescues & Shelters', url: RouteFormatter.dogRescue() },
    ];

    if (pageType == PAGE_TYPES.STATE) {
        bread.push({ name: state, url: RouteFormatter.dogRescueSub({ id: query || slug }) });
    } else if (pageType == PAGE_TYPES.CITY) {
        const fixState = state?.trim().replaceAll('.', '').replaceAll(' ', '-')?.toLowerCase();
        bread.push({ name: state, url: RouteFormatter.dogRescueSub({ id: fixState }) });
        bread.push({ name: city });
    } else if (pageType == PAGE_TYPES.SPECIALIZATION) {
        bread.push({ name: specialization });
    } else if (pageType == PAGE_TYPES.PROFILE) {
        const fixState = state?.trim().replaceAll('.', '').replaceAll(' ', '-')?.toLowerCase();
        const fixCity = city?.trim().replaceAll('.', '').replaceAll(' ', '-')?.toLowerCase();
        const initState = state ? getInitState(state) : '';
        const citySlug = `${fixCity}-${initState?.toLowerCase()}`;
        const canShowCity = !!fixCity && fixCity != 'none';
        fixState && bread.push({ name: state, url: RouteFormatter.dogRescueSub({ id: fixState }) });
        canShowCity && bread.push({ name: city, url: RouteFormatter.dogRescueSub({ id: citySlug }) });
        bread.push({ name: rescueName });
    }

    return bread;
};

const getMainDesc = ({ city, pageType, shortState, state, specialization }) => {
    let mainAddedDesc = 'the United States';

    if (pageType == PAGE_TYPES.STATE) {
        mainAddedDesc = state;
    } else if (pageType == PAGE_TYPES.CITY) {
        mainAddedDesc = `${city}, ${shortState}`;
    }

    let desc = `This list showcases the top dog rescues & shelters in ${mainAddedDesc}. These remarkable organizations have been recognized for their unwavering dedication to the well-being of countless dogs. We've compiled this list by gathering heartfelt testimonials from both the Sniffspot community and the wider public, ensuring a comprehensive perspective on these exceptional shelters.`;

    if (pageType == PAGE_TYPES.SPECIALIZATION) {
        desc = `This list showcases the top ${specialization?.toLowerCase()} rescues and shelters, all making a significant impact on the lives of countless dogs. We've compiled this list by gathering heartfelt testimonials from both the Sniffspot community and the wider public, ensuring a well-rounded perspective on these exceptional organizations.`;
    }

    return desc;
};

const RenderListState = ({ myTitle, pageType, states }) => {
    const title = myTitle || 'Top Rescues & Shelters By State';
    const myNote =
        pageType == PAGE_TYPES.CITY
            ? 'Ordered alphabetically, only included states where there is enough data to compile a list'
            : 'Note: we only include states where we have enough data to compile a solid list';
    const canShowNote = pageType == PAGE_TYPES.CITY || pageType == PAGE_TYPES.COUNTRY;

    return (
        <>
            <h2 className="snif-m1 snif-l2-pc snif-semibold mb-2">{title}</h2>
            {canShowNote && <p className={bDog('p-lora').mix('mb-2')}>{myNote}</p>}
            <ul className={bDog('state-link')}>
                {states?.map((s, i) => (
                    <li key={i}>
                        <a href={RouteFormatter.dogRescueSub({ id: s.slug })} rel={s.noFollow ? 'nofollow' : ''} className="link-style">
                            {s.name || s.state}
                        </a>
                    </li>
                ))}
            </ul>
        </>
    );
};

const RenderListCity = ({ pageType, cities, myTitle }) => {
    const title = myTitle || 'Top Rescues & Shelters By City';

    return (
        <>
            <h2 className="snif-m1 snif-l2-pc snif-semibold mb-2">{title}</h2>
            {pageType == PAGE_TYPES.COUNTRY && (
                <p className={bDog('p-lora').mix('mb-2')}>
                    Note: we only include the top 10 cities where we have enough data to compile a solid list
                </p>
            )}
            <ul className={bDog('city-link')}>
                {cities?.map((s, i) => {
                    const splitSlug = s?.slug?.split('-');
                    const shortState = splitSlug.at(-1).toUpperCase();
                    const name = `${s.name || s.city}, ${shortState}`;

                    return (
                        <li key={i}>
                            <a href={RouteFormatter.dogRescueSub({ id: s.slug })} rel={s.noFollow ? 'nofollow' : ''} className="link-style">
                                {name}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </>
    );
};

const RenderListSpecialized = ({ myTitle, mySpecs }) => {
    const title = myTitle || 'Dog Rescue & Shelter Types';

    return (
        <>
            <h2 className="snif-m1 snif-l2-pc snif-semibold mb-2">{title}</h2>
            <ul className={bDog('city-link')}>
                {mySpecs.map((s, i) => (
                    <li key={i}>
                        <a href={RouteFormatter.dogRescueSub({ id: s.slug })} rel={s.noFollow ? 'nofollow' : ''} className="link-style">
                            {s.name || s.specialization}
                        </a>
                    </li>
                ))}
            </ul>
        </>
    );
};

const faqsTitle = ({ city, pageType, specialization, state }) => {
    let addedType = '';

    switch (pageType) {
        case PAGE_TYPES.CITY:
            addedType = city;
            break;
        case PAGE_TYPES.STATE:
            addedType = state;
            break;
        default:
            break;
    }

    let title = `Sniffspot ${addedType} Dog Rescues & Shelters Frequently Asked Questions`;

    if (pageType == PAGE_TYPES.SPECIALIZATION) {
        title = `Sniffspot ${specialization} Rescues & Shelters Frequently Asked Questions`;
    }
    return title;
};

const RenderFaqs = ({ city, faqContent, pageType, specialization, state }) => {
    const title = faqsTitle({ city, pageType, specialization, state });

    return (
        <>
            <h2 className="snif-m1 snif-l2-pc snif-semibold mb-2">{title}</h2>
            <div itemScope itemType="https://schema.org/FAQPage" className={bDog('faqs')}>
                {faqContent.map((f, i) => (
                    <div key={i} itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
                        <h3 className="snif-m2 snif-semibold mt-3 mb-1" itemProp="name">
                            {f.question}
                        </h3>
                        <div className="snif-p" itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                            <div itemProp="text" dangerouslySetInnerHTML={{ __html: f.answer }} />
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

const RenderStateItem = ({ res }) => {
    const logoUrl = ImageHelper.getUrlFromOptions(res?.logo, `fit-in/${IMG_RESIZES.x512}`);
    const mySlug = res.slug;

    return (
        <>
            <SeoAnimalShelter {...{ ...res }} />
            <li className={bDog('state_list_item')}>
                <PictureSet imgs={logoUrl} width={256} height={256} alt={`${res?.rescueName} Logo`} white />
                <h3 className="snif-m2 snif-m1-pc snif-semibold mt-3 mb-05">
                    <a href={mySlug} target="_blank" rel="noopener noreferrer">
                        {res?.rescueName}
                    </a>
                </h3>
                <p className={`${bDog('p-lora')} ${bDog('state_list_item_bio')}`}>{res?.bio}</p>
                <p className="mt-2">
                    <a href={mySlug} target="_blank" rel="noopener noreferrer" className="snif-s1 snif-medium text-primary text-underline">
                        View profile
                    </a>
                </p>
            </li>
        </>
    );
};

const RenderOtherState = ({ st }) => {
    const isMobile = useMobileScreen();
    const [myRes, setMyRes] = useState(st?.rescues?.slice(0, 3) || []);

    useEffect(() => {
        !isMobile && setMyRes(st?.rescues || []);
    }, []);

    return (
        <div className={bDog('state')}>
            <h2 className="snif-m1 snif-l2-pc snif-semibold text-capitalize mb-3">
                <a href={RouteFormatter.dogRescueSub({ id: st.slug })} rel={st.noFollow ? 'nofollow' : ''}>
                    The Best Dog Rescues & Shelters In {st.name || st.state}
                </a>
            </h2>
            <ul className={bDog('state_list')}>
                {myRes.map((res, i) => (
                    <RenderStateItem key={i} {...{ res }} />
                ))}
            </ul>
        </div>
    );
};

const RenderOtherCity = ({ ct }) => {
    const today = new Date();
    const splitSlug = ct?.slug?.split('-');
    const shortState = splitSlug.at(-1).toUpperCase();
    const name = `${ct.name || ct.city}, ${shortState}`;

    return (
        <div className={bDog('state')}>
            <h2 className="snif-m1 snif-l2-pc snif-semibold text-capitalize mb-3">
                <a href={RouteFormatter.dogRescueSub({ id: ct.slug })} rel={ct.noFollow ? 'nofollow' : ''}>
                    The Best {name} Dog Rescues & Shelters In {today.getFullYear()}
                </a>
            </h2>
            <ul className={bDog('state_list')}>
                {ct?.rescues?.map((res, i) => (
                    <RenderStateItem key={i} {...{ res }} />
                ))}
            </ul>
        </div>
    );
};

const getDesc = ({ addedType, pageType, state, today }) => {
    let desc = `Welcome to the ${today.getFullYear()} United States Sniffspot Top Dog Rescue & Shelter List, showcasing the
                most recommended rescues nationwide, as voted by the Sniffspot community and the public. The Sniffspot
                Best Dog Rescue and Shelter Contest, an annual event, aims to support shelters and rescues in their
                mission to find homes for dogs in need.`;

    if (pageType == PAGE_TYPES.STATE) {
        desc = `Welcome to the ${today.getFullYear()} ${addedType} Sniffspot Top Dog Rescue & Shelter List, highlighting the top rescues and shelters in ${state} chosen by the Sniffspot community and the public.`;
    } else if (pageType == PAGE_TYPES.CITY) {
        desc = `Welcome to the ${today.getFullYear()} ${addedType} Sniffspot Top Dog Rescue & Shelter List, highlighting the top rescues and shelters in ${addedType} chosen by the Sniffspot community and the public.`;
    } else if (pageType == PAGE_TYPES.SPECIALIZATION) {
        desc = `Welcome to the ${today.getFullYear()} Sniffspot Top ${addedType} Rescue & Shelter List, highlighting the top ${addedType} rescues and shelters chosen by the Sniffspot community and the public.`;
    }

    return desc;
};

const Desc2 = ({ city, rescuesCount, pageType, exploreLink, exploreText }) => {
    if (pageType == PAGE_TYPES.STATE) {
        return (
            <p className={bDog('p-lora')}>
                Sponsored by Sniffspot, the largest global network of private dog parks, each park offers secure, private bookings on private land,
                including{' '}
                <a href={RouteFormatter.fencedListings({})} className="link-style">
                    fenced
                </a>
                ,{' '}
                <a href={RouteFormatter.waterListings({})} className="link-style">
                    water
                </a>
                ,{' '}
                <a href={RouteFormatter.indoorListings({})} className="link-style">
                    indoor
                </a>
                , and{' '}
                <a href={RouteFormatter.beachListings({})} className="link-style">
                    beach parks
                </a>
                . As a hub for rescue dogs, our sponsorship underscores our dedication to supporting shelters and rescues. Explore{' '}
                <a href={exploreLink} className="link-style">
                    {exploreText}
                </a>{' '}
                on Sniffspot's platform.
            </p>
        );
    } else if (pageType == PAGE_TYPES.CITY) {
        return (
            <p className={bDog('p-lora')}>
                This list is sponsored by Sniffspot, the largest global network of private dog parks. Sniffspot offers {rescuesCount} private dog
                parks in the {city} area, including{' '}
                <a href={RouteFormatter.fencedListings({})} className="link-style">
                    fenced
                </a>
                ,{' '}
                <a href={RouteFormatter.waterListings({})} className="link-style">
                    water
                </a>
                ,{' '}
                <a href={RouteFormatter.indoorListings({})} className="link-style">
                    indoor
                </a>
                , and{' '}
                <a href={RouteFormatter.beachListings({})} className="link-style">
                    beach parks
                </a>
                . As a hub for rescue dogs, our sponsorship underscores our dedication to supporting shelters and rescues. Explore{' '}
                <a href={exploreLink} className="link-style">
                    {exploreText}
                </a>{' '}
                on Sniffspot's platform.
            </p>
        );
    } else if (pageType == PAGE_TYPES.SPECIALIZATION) {
        return (
            <p className={bDog('p-lora')}>
                This list is sponsored by Sniffspot, the largest global network of private dog parks. Sniffspot offers thousands of private dog parks
                around the world, including{' '}
                <a href={RouteFormatter.fencedListings({})} className="link-style">
                    fenced
                </a>
                ,{' '}
                <a href={RouteFormatter.waterListings({})} className="link-style">
                    water
                </a>
                ,{' '}
                <a href={RouteFormatter.indoorListings({})} className="link-style">
                    indoor
                </a>
                , and{' '}
                <a href={RouteFormatter.beachListings({})} className="link-style">
                    beach parks
                </a>
                . As a hub for rescue dogs, our sponsorship underscores our dedication to supporting shelters and rescues. Explore{' '}
                <a href={exploreLink} className="link-style">
                    {exploreText}
                </a>{' '}
                on Sniffspot's platform.
            </p>
        );
    }

    return (
        <p className={bDog('p-lora')}>
            This list is sponsored by Sniffspot, the largest network of private dog parks globally. Each park offers secure, private bookings on
            private land, catering to various needs including{' '}
            <a href={RouteFormatter.fencedListings({})} className="link-style">
                fenced
            </a>
            ,{' '}
            <a href={RouteFormatter.waterListings({})} className="link-style">
                water
            </a>
            ,{' '}
            <a href={RouteFormatter.indoorListings({})} className="link-style">
                indoor
            </a>
            , and{' '}
            <a href={RouteFormatter.beachListings({})} className="link-style">
                beach parks
            </a>
            . As a popular destination for rescue dogs, Sniffspot's sponsorship of this list reflects our commitment to supporting shelters and
            rescues. Explore{' '}
            <a href={exploreLink} className="link-style">
                {exploreText}
            </a>{' '}
            on Sniffspot's platform.
        </p>
    );
};

const RenderDesc = ({ city, mainDesc, pageType, query, rescuesCount, shortState, slug, state, specialization }) => {
    const today = new Date();
    let addedTitle = ' ';
    let addedType = '';
    let exploreLink = RouteFormatter.listings({});
    let exploreText = 'local dog parks';

    if (pageType == PAGE_TYPES.STATE) {
        addedTitle = ` ${state} `;
        addedType = state;
        exploreLink = RouteFormatter.listings({ first: query || slug });
        exploreText = `${state} dog parks`;
    } else if (pageType == PAGE_TYPES.CITY) {
        addedTitle = ` ${city} `;
        addedType = `${city}, ${shortState}`;
        exploreLink = RouteFormatter.listings({ first: query || slug });
        exploreText = `${city} dog parks`;
    }

    let title = `What's the Sniffspot${addedTitle}Top Dog Rescue & Shelter List About?`;

    if (pageType == PAGE_TYPES.SPECIALIZATION) {
        title = `What's the Sniffspot Top ${specialization} Rescue & Shelter List About?`;
        addedType = `${specialization}`;
        exploreLink = RouteFormatter.listings({});
    }

    const desc = getDesc({ addedType, pageType, state, today });

    return (
        <>
            <h2 className="snif-m1 snif-l2-pc snif-semibold mb-2">{title}</h2>
            <p className={bDog('p-lora').mix('mb-3')}>{desc}</p>
            <Desc2 {...{ city, exploreLink, exploreText, pageType, rescuesCount, state }} />
            <p className={bDog('p-lora').mix('mt-3')}>{mainDesc}</p>
        </>
    );
};

const RenderRemainRescues = ({ blogPost, remainRes }) => (
    <div>
        <h2 className="snif-m1 snif-l2-pc snif-semibold text-capitalize mb-3">See More Dog Rescues & Shelters In {blogPost.state}</h2>
        <ul className={bDog('city-link').mix('remain')}>
            {remainRes?.map((s, i) => {
                return (
                    <li key={i}>
                        <a href={s.slug} target="_blank" rel="noopener noreferrer" className="link-style">
                            {s.rescueName}
                        </a>
                    </li>
                );
            })}
        </ul>
        <Divider />
    </div>
);

const RenderRescueContent = ({ blogPost, faqContent, mainDesc, shortState }) => {
    const myType = blogPost?.pageType;
    const isState = myType == PAGE_TYPES.STATE;
    const isCity = myType == PAGE_TYPES.CITY;
    const isCountry = myType == PAGE_TYPES.COUNTRY;
    const isSpec = myType == PAGE_TYPES.SPECIALIZATION;
    const canShowMoreRes = blogPost?.rescues?.length > RESCUES_LIMIT;
    const remainRes =
        isState && canShowMoreRes ? blogPost?.rescues?.slice(RESCUES_LIMIT).sort((a, b) => a.rescueName?.localeCompare(b.rescueName)) : [];
    let resSpecTitle = 'See The Best Dog Rescues & Shelters By Specialization';
    let resStateTitle = 'See The Best Dog Rescues & Shelters In Other States';
    let resCitiesTitle = `See The Best Dog Rescues & Shelters By City In ${blogPost?.state}`;
    if (isCity) {
        resCitiesTitle = `See The Best Dog Rescues & Shelters In Other Cities Near ${blogPost?.city}`;
    } else if (isSpec) {
        resSpecTitle = 'See The Best Dog Rescues & Shelters By Type In The United States';
    }

    return (
        <div className="mx-2 mx-md-0 my-4">
            {isState && remainRes.length > 0 && <RenderRemainRescues {...{ blogPost, remainRes }} />}
            {isCountry && blogPost?.states?.map((st, i) => <RenderOtherState key={i} {...{ st }} />)}
            {isState && blogPost?.cities?.map((ct, i) => <RenderOtherCity key={i} {...{ ct }} />)}
            {isCountry && isState && <Divider />}
            <RenderDesc {...{ ...blogPost, mainDesc, shortState }} />
            <Banner1 />
            {isState || isCity ? (
                <>
                    {blogPost?.cities?.length > 0 && (
                        <>
                            <RenderListCity myTitle={resCitiesTitle} {...{ ...blogPost }} />
                            <Divider />
                        </>
                    )}
                    {blogPost?.states?.length > 0 && (
                        <>
                            <RenderListState myTitle={resStateTitle} {...{ ...blogPost }} />
                        </>
                    )}
                    {blogPost?.specializations?.length > 0 && isState && (
                        <>
                            <Divider />
                            <RenderListSpecialized myTitle={resSpecTitle} mySpecs={blogPost.specializations} />
                        </>
                    )}
                </>
            ) : isSpec ? (
                <>{blogPost?.specializations?.length > 0 && <RenderListSpecialized myTitle={resSpecTitle} mySpecs={blogPost.specializations} />}</>
            ) : (
                <>
                    {blogPost?.states?.length > 0 && (
                        <>
                            <RenderListState {...{ ...blogPost }} />
                            <Divider />
                        </>
                    )}
                    {blogPost?.cities?.length > 0 && (
                        <>
                            <RenderListCity {...{ ...blogPost }} />
                            <Divider />
                        </>
                    )}
                    {blogPost?.specializations?.length > 0 && <RenderListSpecialized mySpecs={blogPost.specializations} />}
                </>
            )}
            <Divider />
            <RenderFaqs {...{ ...blogPost, faqContent }} />
            <Banner2 />
        </div>
    );
};

const RenderRescue = ({ r, i, handleGo }) => {
    const logoUrl = ImageHelper.getUrlFromOptions(r.logo, `fit-in/${IMG_RESIZES.x512}`);
    let testi = r.testimonials.length > 0 ? r.testimonials[0].testimonial : '';
    const isOverflow = testi.length > MAX_TESTI_CHAR_LIMIT;
    testi = `"${testi.slice(0, MAX_TESTI_CHAR_LIMIT)}${isOverflow ? '...' : ''}"`;
    const initState = r.state ? getInitState(r.state) : '';
    const rescueLoc = `${r.city || ''}${r.city && r.state ? ', ' : ''}${initState || r.state}`;
    const canShowRanks = Boolean(r.countryRank || r.stateRank || r.cityRank);

    return (
        <div className={bDog('list_item')} onClick={(e) => handleGo(e, r.slug)}>
            <div className={bDog('list_item_img-cont')}>
                <PictureSet imgs={logoUrl} method={i === 0 ? 'eager' : 'lazy'} alt={`${r.rescueName} — Sniffspot`} noLoad />
            </div>
            <p className="snif-m2 snif-semibold mt-1">
                <a href={r.slug} target="_blank" rel="noreferrer">
                    {r.rescueName}
                </a>
            </p>
            {canShowRanks && (
                <div className={bDog('list_item_ranks')}>
                    <SvgTrophy />
                    <RenderRanks {...r} />
                </div>
            )}
            {r.bio && <p className={bDog('list_item_bio').mix('snif-s1 text-deep')}>{r.bio}</p>}
            {r.specializations.length > 0 && (
                <div className={bDog('list_item_specs')}>
                    {r.specializations.slice(0, 4).map((s, i) => (
                        <div key={i}>{s}</div>
                    ))}
                </div>
            )}
            {r.testimonials.length > 0 && (
                <div className={bDog('list_item_testi')}>
                    <SvgCommentQuote />
                    <p className="snif-s1 text-medium">
                        {testi}
                        {isOverflow && (
                            <>
                                {' '}
                                <span className="text-primary text-underline">more</span>
                            </>
                        )}
                    </p>
                </div>
            )}
            <div className={bDog('list_item_loc')}>
                <SvgPin />
                <p className="snif-s1 text-medium">{rescueLoc}</p>
            </div>
        </div>
    );
};

const RenderSearchComp = ({
    activeFilters,
    address,
    handleSearch,
    handleToMyLoc,
    isFocus,
    loc,
    onChangeLoc,
    onSelectLoc,
    toggleDelete,
    toggleFocus,
    toggleOpenFilter,
}) => {
    const activeFiltersCount = activeFilters.length;

    return (
        <>
            <div className={bDog('search-comp-container').mix(isFocus ? '' : 'd-none')}>
                <div className={bDog('search-comp', { real: true })}>
                    <LocationSearch
                        address={address}
                        value={loc}
                        handleToMyLoc={handleToMyLoc}
                        onChange={onChangeLoc}
                        onSelect={onSelectLoc}
                        toggleDelete={toggleDelete}
                        googleMapURL={GOOGLE_MAP_URL}
                        loadingElement={<div style={{ height: '100%' }} />}
                    />
                    <SvgSearch className={bDog('search-comp_search-icon')} />
                    <div className={bDog('search-comp_filter-icon')} onClick={toggleOpenFilter}>
                        <SvgFilterNew />
                        {activeFiltersCount > 0 && <div className={bDog('search-comp_filter-count')}>{activeFiltersCount}</div>}
                    </div>
                </div>
                <SniffButton size="lg" className="position-relative mt-2" onClick={handleSearch} block>
                    Search
                </SniffButton>
            </div>
            {isFocus && <div className={bDog('search-comp-overlay')} onClick={toggleFocus} />}
        </>
    );
};

const RenderFiltersButton = ({ activeFilters, toggleFilter, toggleOpenFilter }) => (
    <div className={bDog('toggle-filters')}>
        {SPEC_TYPES.map((s, i) => (
            <div key={i} className={bDog('toggle-filters_item', { active: activeFilters.includes(s) })} onClick={() => toggleFilter(s)}>
                {s}
            </div>
        ))}
        <div className={bDog('toggle-filters_item')} onClick={toggleOpenFilter}>
            <SvgFilterNew />
            <span>More...</span>
        </div>
    </div>
);

const RenderEmptyRescues = () => (
    <div className={bDog('empty-comp')}>
        <SvgPin width={80} height={80} />
        <p className="snif-m2 snif-semibold mt-5">Not finding the dog rescues you're looking for?</p>
        <p className="snif-p mt-2">Try searching a different location or explore nearby areas with available dog rescues.</p>
    </div>
);

const DogRescues = ({ dataSSR, categoriesSSR, useStateSSR, serverSSR }) => {
    const today = new Date();
    const thisYear = today.getFullYear();
    const isMobile = useMobileScreen();
    const { mapkitToken } = serverSSR ? {} : useGetMapkitToken.default();
    const [loc, setLoc] = useState('');
    const [page, setPage] = useState(1);
    const [init, setInit] = useState(true);
    const [initLoading, setInitLoading] = useState(!useStateSSR);
    const [searchLoading, setSearchLoading] = useState(false);
    const [mapRect, setMapRect] = useState(null);
    const [isMap, setIsMap] = useState(false);
    const [isFocus, setIsFocus] = useState(false);
    const [openFilter, setOpenFilter] = useState(false);
    const [activeFilters, setActiveFilters] = useState([]);
    const [tempFilters, setTempFilters] = useState(activeFilters);
    const [address, setAddress] = useState({ addr: null, coor: null, bounds: null, zoom: null });
    const [chosenAddress, setChosenAddress] = useState({ addr: null, coor: null, bounds: null, zoom: null });
    const [mapHeight, setMapHeight] = useState({});

    const { getDogRescuesPages } = serverSSR ? {} : useGetDogRescuesPages.default();
    const { data: clientData, loading } = useStateSSR ? {} : useGetDogRescuesPage.default(window?.location?.pathname?.split('/')[2]);
    const { data: clientCat } = useStateSSR ? {} : useGetBlogCategories.default();
    const blogPost = dataSSR || clientData || {};
    const blogCategories = categoriesSSR || clientCat || [];
    const recentPosts = blogPost?.recentPosts || [];
    const faqContent = blogPost?.faqs?.length > 0 ? blogPost.faqs : DEFAULT_FAQS || DEFAULT_FAQS;
    const pageSlug = blogPost?.query || blogPost?.slug;
    const shortState = pageSlug?.split('-')?.at(-1)?.toUpperCase();
    const listBread = getBread({ ...blogPost });
    const mainDesc = getMainDesc({ ...blogPost, shortState });

    const [filteredRescues, setFilteredRescues] = useState(blogPost?.rescues || []);
    const [filteredTotalPages, setFilteredTotalPages] = useState(Math.ceil(blogPost?.rescuesCount / RESCUES_LIMIT) || 1);
    const [filteredRescuesCount, setFilteredRescuesCount] = useState(blogPost?.rescuesCount || 0);
    const rescuesCountText =
        initLoading || searchLoading
            ? 'Searching..'
            : filteredRescuesCount > 0
              ? `${filteredRescuesCount} dog rescues found`
              : 'No dog rescues found';
    const isEmpty = !initLoading && !searchLoading && filteredRescuesCount == 0;
    const metadata = { currentPage: page, totalPages: filteredTotalPages, totalCount: filteredRescuesCount };
    const isState = blogPost?.pageType == PAGE_TYPES.STATE;
    const canShowMoreRes = blogPost?.rescues?.length > RESCUES_LIMIT;
    const top30Res = isState && canShowMoreRes ? filteredRescues?.slice(0, RESCUES_LIMIT) : filteredRescues;
    const topRes = isState ? top30Res : filteredRescues;

    let mainTitle = `The Best Dog Rescues & Shelters in the United States in ${thisYear}`;

    if (blogPost?.pageType == PAGE_TYPES.STATE) {
        mainTitle = `The Best ${blogPost?.state} Dog Rescues & Shelters in ${thisYear}`;
    } else if (blogPost?.pageType == PAGE_TYPES.CITY) {
        mainTitle = `The Best ${blogPost?.city}, ${shortState} Dog Rescues & Shelters in ${thisYear}`;
    } else if (blogPost?.pageType == PAGE_TYPES.SPECIALIZATION) {
        mainTitle = `The Best ${blogPost?.specialization} Rescues & Shelters in ${thisYear}`;
    }

    const toggleMap = () => setIsMap((m) => !m);
    const toggleFocus = () => setIsFocus((o) => !o);
    const onChangeLoc = (e) => setLoc(e);
    const handleRefresh = () => getDogRescuesPaginated({ page: 1, bounds: mapRect });
    const handleResetFilters = () => setActiveFilters([]);

    const onSelectLoc = async (addr) => {
        const results = await geocodeByAddress(addr);
        const coor = await getLatLng(results[0]);
        setAddress({ addr, coor, zoom: 50000 });
    };

    const toggleDelete = () => {
        setAddress({ addr: '', coor: null, zoom: null });
        setLoc('');
    };

    const handleToMyLoc = ({ force = false }) => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const { latitude, longitude } = position.coords;
                const myAddr = { addr: 'My Location', coor: { lat: latitude, lng: longitude }, zoom: 50000 };
                setAddress(myAddr);
                force && setChosenAddress(myAddr);
            });
        }
    };

    const applyFilterChanges = () => {
        setActiveFilters(tempFilters);
        setOpenFilter(false);
    };

    const toggleFilter = (spec) => {
        let newFilters = structuredClone(activeFilters);
        const filterIdx = activeFilters.findIndex((s) => s == spec);

        if (filterIdx > -1) {
            newFilters.splice(filterIdx, 1);
        } else {
            newFilters.push(spec);
        }
        setActiveFilters(newFilters);
    };

    const toggleTempFilter = (spec) => {
        let newFilters = structuredClone(tempFilters);
        const filterIdx = tempFilters.findIndex((s) => s == spec);

        if (filterIdx > -1) {
            newFilters.splice(filterIdx, 1);
        } else {
            newFilters.push(spec);
        }
        setTempFilters(newFilters);
    };

    const toggleOpenFilter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpenFilter((o) => {
            const newOpen = !o;

            if (!newOpen) {
                setTempFilters(activeFilters);
            }

            return newOpen;
        });
    };

    const handleGo = (e, slug) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(slug, '_blank');
    };

    const handleSearch = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setChosenAddress(address);
        setIsFocus(false);
    };

    const getDogRescuesPaginated = async ({ bounds, center, page, specializations }) => {
        try {
            setSearchLoading(true);
            let defBounds = bounds || chosenAddress.bounds;
            if (defBounds?.ne?.lat >= 90) {
                defBounds.ne.lat = 85;
            } else if (defBounds?.sw?.lat <= -90) {
                defBounds.ne.lat = -85;
            }
            const defCenter = defBounds ? undefined : center || chosenAddress.coor;
            let specs = specializations || activeFilters;
            specs = specs.length > 0 ? specs : undefined;

            const res = await getDogRescuesPages({
                variables: {
                    bounds: defBounds,
                    center: defCenter,
                    page,
                    limit: RESCUES_LIMIT,
                    specializations: specs,
                },
            });

            if (center || page == 1) {
                setPage(1);
            }

            setFilteredRescues(res.data.dogRescues.collection);
            setFilteredTotalPages(res.data.dogRescues.metadata.totalPages);
            setFilteredRescuesCount(res.data.dogRescues.metadata.totalCount);
        } catch (error) {
            console.warn(error);
        }
        setSearchLoading(false);
    };

    useEffect(() => {
        if (!blogPost.pageType) {
            return;
        }

        !useStateSSR && setSearchLoading(true);

        if (blogPost.pageType == PAGE_TYPES.COUNTRY || blogPost.pageType == PAGE_TYPES.SPECIALIZATION) {
            const initAddr = {
                addr: blogPost.country,
                coor: { lat: 39.7647045, lng: -101.4065544 },
                bounds: {
                    ne: {
                        lat: 82.90934135580581,
                        lng: -74.34656965851104,
                    },
                    sw: {
                        lat: -3.3799323558058063,
                        lng: -128.46653914148897,
                    },
                },
                zoom: 4000000,
            };
            setAddress(initAddr);
            setChosenAddress(initAddr);

            if (blogPost.pageType == PAGE_TYPES.SPECIALIZATION) {
                setActiveFilters([blogPost.specialization]);
                setTempFilters([blogPost.specialization]);
            }
        } else if (blogPost.pageType == PAGE_TYPES.CITY) {
            const initAddr = {
                addr: blogPost.city + ', ' + blogPost.state,
                coor: { lat: blogPost.latitude, lng: blogPost.longitude },
                zoom: 50000,
            };
            setAddress(initAddr);
            setChosenAddress(initAddr);
        } else if (blogPost.pageType == PAGE_TYPES.STATE) {
            const initAddr = {
                addr: blogPost.state,
                coor: { lat: blogPost.latitude, lng: blogPost.longitude },
                zoom: 65000,
            };
            setAddress(initAddr);
            setChosenAddress(initAddr);
        }

        if (!useStateSSR) {
            setFilteredRescues(blogPost.rescues);
            setFilteredTotalPages(Math.ceil(blogPost.rescuesCount / RESCUES_LIMIT));
            setFilteredRescuesCount(blogPost.rescuesCount);
        }

        setTimeout(() => setInit(false), 250);
        !useStateSSR && setTimeout(() => setSearchLoading(false), 250);
    }, [blogPost]);

    useEffect(() => {
        if (loading || init || initLoading || searchLoading) {
            return;
        }

        setTempFilters(activeFilters);
        getDogRescuesPaginated({ page: 1, specializations: activeFilters, bounds: mapRect });
    }, [activeFilters]);

    useEffect(() => {
        if (loading || init || initLoading || searchLoading) {
            return;
        }

        getDogRescuesPaginated({ page, specializations: activeFilters, bounds: mapRect });
    }, [page]);

    useEffect(() => {
        if (loading || init || initLoading || searchLoading) {
            return;
        }

        getDogRescuesPaginated({ page: 1, specializations: activeFilters, center: chosenAddress.coor });
    }, [chosenAddress]);

    useEffect(() => {
        if (clientData) {
            setInitLoading(false);
        }
    }, [clientData]);

    useEffect(() => {
        if (!isMobile) {
            return;
        }

        const appShowCookie = CookieService.default.get(COOKIE_PARAM_NAME.SNIFF_APP_SHOW_BANNER);

        if (appShowCookie === 'true') {
            setMapHeight({ height: 'calc(100dvh - 141px)' });
        } else if (appShowCookie === 'false') {
            setMapHeight({ height: 'calc(100dvh - 56px)' });
        }
    }, [isMobile]);

    return (
        <>
            {useStateSSR && (
                <>
                    <NavigationGuestUnauth />
                </>
            )}
            <div className={`${b()} ${bDog()}`}>
                <div className={bDog('desktop-sub-nav').mix('d-none d-md-block b-bot')}>
                    <BlogTopNav />
                </div>
                <div className={bDog('rescues-content')}>
                    <div className={bDog('rescues-content_left')}>
                        <div className="d-none d-md-block">
                            <SpotBreadcrumbs {...{ listBread, SSR: !!useStateSSR, general: true }} />
                        </div>
                        <div className={bDog('rescues-content_left_top-bar')}>
                            <div className={bDog('rescues-content_left_top-bar_back-icon')}>
                                <SvgChevronLeft height={14} />
                            </div>
                            <div className={bDog('search-comp')} onClick={toggleFocus}>
                                <SvgSearch className={bDog('search-comp_search-icon')} />
                                <p className={bDog('search-comp_addr').mix('snif-s1 text-medium')}>{address.addr || 'United States'}</p>
                                <div className={bDog('search-comp_filter-icon')} onClick={toggleOpenFilter}>
                                    <SvgFilterNew />
                                    {activeFilters.length > 0 && <div className={bDog('search-comp_filter-count')}>{activeFilters.length}</div>}
                                </div>
                            </div>
                            <div className={bDog('rescues-content_left_top-bar_map-icon')} onClick={toggleMap}>
                                {isMap ? <SvgList width={24} height={24} /> : <SvgMap width={24} height={24} />}
                            </div>
                            <RenderSearchComp
                                {...{
                                    activeFilters,
                                    address,
                                    handleSearch,
                                    handleToMyLoc,
                                    isFocus,
                                    loc,
                                    onChangeLoc,
                                    onSelectLoc,
                                    toggleDelete,
                                    toggleFocus,
                                    toggleOpenFilter,
                                }}
                            />
                        </div>
                        <div className={bDog('filters-comp-mobile')}>
                            <RenderFiltersButton {...{ activeFilters, toggleFilter, toggleOpenFilter }} />
                        </div>
                        <div className={bDog('maps', { empty: !mapkitToken || !chosenAddress.coor, hide: !isMap })} style={mapHeight}>
                            {((isMobile && isMap) || !isMobile) && mapkitToken && chosenAddress.coor ? (
                                <>
                                    <SniffAppleMapsRescue
                                        center={{ latitude: parseFloat(chosenAddress.coor?.lat), longitude: parseFloat(chosenAddress.coor?.lng) }}
                                        cameraDistance={chosenAddress.zoom}
                                        {...{
                                            mapkitToken,
                                            setMapRect,
                                            filteredRescues,
                                        }}
                                    />
                                    <div className="refresh-spot" onClick={handleRefresh}>
                                        {initLoading || searchLoading ? <SvgLoading /> : <SvgRefresh />}
                                        Search this area
                                    </div>
                                    <div className="go-to-my-loc" onClick={() => handleToMyLoc({ force: true })}>
                                        <SvgMyLocation />
                                    </div>
                                </>
                            ) : (
                                <Preloader />
                            )}
                        </div>
                    </div>
                    <div className={bDog('rescues-content_right', { hide: isMap })}>
                        <div className="d-md-flex justify-content-between align-items-end">
                            <div className="d-md-none mt-1">
                                <SpotBreadcrumbs {...{ listBread, SSR: !!useStateSSR, general: true }} />
                            </div>
                            <h1 className={bDog('rescues-content_right_title')}>{mainTitle}</h1>
                            <p className={bDog('rescues-content_right_found-text')}>
                                <span className="snif-s1 snif-medium text-medium">{rescuesCountText}</span>
                                {activeFilters.length > 0 && (
                                    <span className="snif-s1 snif-medium text-deep text-underline c-pointer ms-2" onClick={handleResetFilters}>
                                        Clear all filters
                                    </span>
                                )}
                            </p>
                        </div>
                        <div className="d-none d-md-block">
                            <RenderFiltersButton {...{ activeFilters, toggleFilter, toggleOpenFilter }} />
                        </div>
                        <div className={bDog('list')}>
                            {initLoading || searchLoading
                                ? [...Array(12)].map((_, i) => <SkeletonSpotItem key={i} className={bDog('list_item')} />)
                                : topRes?.map((r, i) => <RenderRescue key={i} {...{ r, i, handleGo }} />)}
                            {isEmpty && <RenderEmptyRescues />}
                        </div>
                        <PaginationNextSSR className="px-2 px-md-0 w-100" {...{ metadata, setPage, items: filteredRescues }} />
                    </div>
                </div>
                <div className={bDog('content', { hide: isMap })}>
                    <RenderRescueContent {...{ blogPost, faqContent, mainDesc, shortState }} />
                </div>
                <div className={`desktop-container ${isMap ? 'mobile-hide' : ''}`}>
                    <div className="mx-2 mx-md-0">
                        <h2 className="snif-m1 snif-l2-pc snif-semibold snif-bold-pc mb-3 mb-md-5">Most recent articles</h2>
                        <div className={b('recent')}>
                            {recentPosts.map((v) => (
                                <Fragment key={v.id}>
                                    <BlogArticleSimple data={v} {...{ useStateSSR }} />
                                    <BlogArticleDesktopLow data={v} {...{ useStateSSR }} />
                                </Fragment>
                            ))}
                        </div>
                        <div className="d-md-none">
                            <h5 className="snif-m2 snif-semibold mb-3">Related articles</h5>
                            {blogPost?.relatedPosts?.map((v) => (
                                <BlogArticleSimple key={v.id} data={v} {...{ useStateSSR }} />
                            ))}
                        </div>
                        <h2 className="snif-m1 snif-l2-pc snif-semibold snif-bold-pc mb-3 mb-md-5 pt-3 pt-md-0">Top dog guides per area</h2>
                        <BlogCategories categories={blogCategories} />
                    </div>
                </div>
            </div>
            <div className={bDog('rescue-footer', { hide: isMap })}>
                <BlogFooter {...{ useStateSSR }} />
                <FooterNew isHome isShowCities={false} SSR={useStateSSR} />
            </div>
            <ModalMobile title="Filter search" isOpen={openFilter} toggle={toggleOpenFilter}>
                <h2 className="snif-m1 snif-semibold mb-05">Type</h2>
                {FULL_SPEC_TYPES.map((s, i) => {
                    const myId = slugify(s) + '-' + i;

                    return (
                        <div key={i} className={bDog('modal-list-filter-item')}>
                            <label htmlFor={myId} className={bDog('modal-list-filter-item_label').mix('snif-p')}>
                                {s}
                            </label>
                            <SniffCheckbox id={myId} checked={tempFilters.includes(s)} onChange={() => toggleTempFilter(s)} />
                        </div>
                    );
                })}
                <div className={bDog('modal-list-filter-footer')}>
                    <SniffButton size="lg" color="secondary" onClick={toggleOpenFilter}>
                        Cancel
                    </SniffButton>
                    <SniffButton size="lg" onClick={applyFilterChanges}>
                        See results
                    </SniffButton>
                </div>
            </ModalMobile>
        </>
    );
};

export default DogRescues;
